module.exports = __webpack_public_path__ + "static/media/BreakingNews.47a44e47.jpg";